import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const AltepPelletsDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazan <span className={styles.highlight}>Altep Pellets</span></p>
      <p className={styles.text}>
        Cazanele  de  tip  (KT-2EPG) sunt  proiectate  pentru  încălzirea  clădirilor  rezidențiale  și  industriale  în  regim  automat.  Cazanul pe peleți ALTEP Pellet (KT-2EPG)  funcționează automat și nu necesită supraveghere constantă. Pentru transportul automat al combustibilului, este prevăzut un rezervor de combustibil cu snec, care este situat deasupra cazanului. Combustibilul  pentru  cazanele  de  tip  (KT-2EPG) este  peleți  de  lemn  care  îndeplinesc  cerințele  standardului  A1  plus.
      </p>
      <p className={styles.text}>
        Cazanul este echipat cu un controler, care asigura  funcționarea cazanului cu alimentare  și aprindere automată a combustibilului solid granular. Detectarea flăcării se realizează folosind un senzor de temperatură a gazelor arse. Capacitatea de a folosi termostate de cameră, ajută la menținerea unei temperaturi confortabile în încăperile încălzite
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>33 kW</th>
              <th>40 kW</th>
              <th>50 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>1.3</td>
              <td>1.7</td>
              <td>2.4</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="5">Dimensiuni camera de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Consum de combustibil la putere nominală</td>
              <td>kg/h</td>
              <td>4.1</td>
              <td>5.4</td>
              <td>7.5</td>
            </tr>
            <tr>
              <td>Capacitatea buncărului de combustibil</td>
              <td>dm³</td>
              <td>153</td>
              <td>188</td>
              <td>201</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>58</td>
              <td>75</td>
              <td>100</td>
            </tr>
            <tr>
              <td>Greutate cazan fără apă</td>
              <td>kg</td>
              <td>270</td>
              <td>300</td>
              <td>370</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="3">100-150</td>
            </tr>
            <tr>
              <td>Temperatura min. recomandată</td>
              <td>°C</td>
              <td colSpan="3">58</td>
            </tr>
            <tr>
              <td>Temperatura max. permisă a apei din cazan</td>
              <td>°C</td>
              <td colSpan="3">85</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei</td>
              <td>mPa</td>
              <td colSpan="3">0.15</td>
            </tr>
            <tr>
              <td>Consum energie electrică, max (în timpul operației)</td>
              <td>W</td>
              <td colSpan="3">80</td>
            </tr>
            <tr>
              <td>Consum energie electrică, max (în timpul operației)</td>
              <td>W</td>
              <td colSpan="3">500</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="5">Parametri recomandați burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>95</td>
              <td>95</td>
              <td>95</td>
            </tr>
            <tr>
              <td>Diametrul intern</td>
              <td>mm</td>
              <td>110</td>
              <td>110</td>
              <td>110</td>
            </tr>
            <tr>
              <td>Înălțime (min. recomandată)</td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
            </tr>
            <tr>
              <td>Diametru racord supapă de siguranță</td>
              <td>mm</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
            </tr>
            <tr>
              <td>Eliberarea supapei de siguranță a presiunii necesare</td>
              <td>mPa</td>
              <td>0.20</td>
              <td>0.20</td>
              <td>0.20</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  );
};

export const AltepPelletsDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [585, 585, 695] },
    { param: "H", unit: "mm", values: [1555, 1555, 1600] },
    { param: "H1", unit: "mm", values: [1505, 1505, 1555] },
    { param: "H2", unit: "mm", values: [645, 645, 695] },
    { param: "L", unit: "mm", values: [1310, 1460, 1460] },
    { param: "L1", unit: "mm", values: [750, 900, 900] },
    { param: "D", unit: "mm", values: [108, 108, 108] }
  ]

  const headers = ["Parametri", "U.M.", "33 kW", "40 kW", "50 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/AltepPelletsSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div >
  );
};